export default __webpack_public_path__ + "static/media/r12.54c792c0.jpg";